import {
  RESEND_INVITE,
  RESEND_INVITE_SUCCESS,
  RESEND_INVITE_FAILURE,
} from './action';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const resendInviteReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESEND_INVITE:
      return { ...state, loading: true };
    case RESEND_INVITE_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case RESEND_INVITE_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default resendInviteReducer;
